const htmlUnescapes = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": '"',
	"&reg;": "®",
};

/** Used to match HTML entities and HTML characters. */
const reEscapedHtml = /&(?:amp|lt|gt|quot|reg);/g;
const reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * Converts the HTML entities `&amp;`, `&lt;`, `&gt;`, `&quot;` and `&#39;` `&reg;` in `string`
 */
export const unescape = string => {
	return string && reHasEscapedHtml.test(string)
		? string.replace(reEscapedHtml, entity => htmlUnescapes[entity] || "'")
		: string || "";
};
